import { useCallback, useState } from 'react'

import { FileCode, FileImage, Settings } from 'lucide-react'
import { Button, DefaultSheet, DefaultTooltip, NavigationTabs, NavigationTabsContent, NavigationTabsList, NavigationTabsTrigger, Separator, SheetBody, SheetFooter } from 'twyne-new.ui'

import { useBuilderStore } from '@/components/builder/utils/store'
import { useTailwindCssConfig } from '@/components/builder/utils/tailwindConfig/hooks'

import Images from './Images'
import TailwindCssConfig from './TailwindCssConfig'
// import ThemeProperties from './ThemeProperties'

export default function BuilderConfig() {
  const [open, setOpen] = useState(false)
  const { setValue } = useTailwindCssConfig()
  const { postBuilder: { history: { preview } } } = useBuilderStore()
  const [tailwindCssValue, setTailwindCssValue] = useState('')
  const [disabledApply, setDisabledApply] = useState(false)

  const handleChangeConfig = useCallback((key, value) => {
    setDisabledApply(false)
    switch (key) {
      case 'tailwindCssConfig':
        setTailwindCssValue(value)
        break
    }
  }, [])

  const handleApplyConfig = () => {
    setDisabledApply(true)
    setValue(tailwindCssValue)
  }

  const value = {
    tailwindCssConfig: tailwindCssValue,
  }

  if (preview) {
    return null;
  }

  return <DefaultSheet wrapperProps={{ open, onOpenChange: setOpen }} trigger={<EditButton />} title='Builder Config' contentProps={{ size: 'xl' }}>
    <SheetBody>
      <NavigationTabs defaultValue='tailwind-css-config'>
        <NavigationTabsList>
          {/* <TabsTrigger value='tailwind-config'>Tailwind Config</TabsTrigger> */}
          <NavigationTabsTrigger value='tailwind-css-config'>
            <FileCode size={16} />
            Tailwind CSS Config
          </NavigationTabsTrigger>
          <NavigationTabsTrigger value='images'>
            <FileImage size={16} />
            Images
          </NavigationTabsTrigger>
        </NavigationTabsList>
        {/* <ThemeProperties /> */}
        <Separator className="my-4" />
        <NavigationTabsContent value='tailwind-css-config' id="tailwind-css-config-container" className="data-[state=active]:border-2 twy-border-base data-[state=active]:rounded-md data-[state=active]:h-[50vh] data-[state=active]:flex data-[state=active]:flex-row">
          <TailwindCssConfig isOpen={open} value={value} onChange={handleChangeConfig} />
        </NavigationTabsContent>
        <NavigationTabsContent value='images' id="images-container">
          <Images />
        </NavigationTabsContent>
      </NavigationTabs>
    </SheetBody>
    <SheetFooter>
      <Button color='neutral' variant='ghost' onClick={() => setOpen(false)}>Cancel</Button>
      <Button color='accent' onClick={handleApplyConfig} disabled={disabledApply}>Apply</Button>
    </SheetFooter>
  </DefaultSheet >
}

function EditButton() {
  return <DefaultTooltip content="Edit Builder Config" >
    <Button className="items-center" color='accent' variant='outline'>
      <Settings size={16} />
    </Button>
  </DefaultTooltip>
}

